export const PRIVACY_URL = '/personvern'
export const TERMS_URL = '/brukervilkar'
export const ARTIST_TERMS_URL = '/brukervilkar-artist'
export const EVENT_PLANNER_TERMS_URL = '/brukervilkar-arrangor'
